import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField, rhfValidateToBottomSheet } from '~/utils/react-hook-form.utils';
export default function MinPriceTextField(param) {
    let { onChange = ()=>{}, testId } = param;
    const { control, watch, trigger } = useFormContext();
    const { t: minPriceTexts } = useLocaleKeys('billing.minPrice');
    const [pricing, price] = watch([
        'pricing',
        'price'
    ]);
    useEffect(()=>{
        trigger('minPrice');
    }, [
        pricing,
        price
    ]);
    const validate = (minPrice)=>{
        if (minPrice && +minPrice < 0) return minPriceTexts.validation.mustBeNonNegative();
        if (minPrice && price && +minPrice >= +price) return minPriceTexts.validation.cannotExceedOrEqualMax();
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "minPrice",
        rules: {
            validate
        },
        render: (renderProps)=>{
            const connectedProps = connectControllerToTextField(renderProps);
            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                mobile: {
                    renderAsCard: true
                },
                bi: {
                    name: 'min_price'
                },
                isMoney: true,
                alwaysShrinkLabel: true,
                inputProps: positiveQuantityInputProps,
                label: minPriceTexts.label(),
                prefix: "$",
                testId: testId,
                validateInBottomSheet: rhfValidateToBottomSheet(validate)
            }, connectedProps), {
                onChange: (e)=>{
                    connectedProps.onChange(e);
                    onChange(e.target.value);
                }
            }));
        }
    });
}
